import { Button, Menu, MenuItem, QueryState, QueryStateContent, Stack } from 'src/app/components'
import { SALES_PROMO_RESULT_ITEMS, SALES_PROMO_RESULT_ITEMS_ARRAY, useSalesPromoDetailTabResult } from './SalesPromoDetailTabResult.hook'
import { SalesPromoResult, SalesPromoResultItem } from '../../../models/SalesPromo.model'
import { Refs } from 'src/app/utils/refs-utils'
import { XlsIcon } from 'src/app/components/Icons'
import TablePrizesResult from './TabResultContent/TablePrizesResult'
import { hasArray } from 'src/app/utils/array-utils'
import { usePermissions } from 'src/app/hooks/permissions-hook'

function SalesPromoDetailTabResult() {
  const state = useSalesPromoDetailTabResult()
  const permission = usePermissions()
  const data: SalesPromoResult = state.resultDetail.data
  const is_direct_cashback_point = state.generalInfo.data?.is_direct_cashback_point

  const handleDownloadExport = async () => {
    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 10).replace(/-/g, '');
    const name = `campaign_participantresult_${formattedDate}`;
    try {
      await state.exportResultDetail.download(`${name}.xlsx`, null);
      Refs.pageToast.show({
        severity: 'success',
        message: `${name} successfully exported (.xlsx).`
      });

    } catch (error) {
      console.error("🚀 ~ handleDownloadData ~ error:", error);
    }
  };

  const tables: { type: SALES_PROMO_RESULT_ITEMS, data?: SalesPromoResultItem[] }[] = SALES_PROMO_RESULT_ITEMS_ARRAY.map((item: { value: SALES_PROMO_RESULT_ITEMS }) => {
    return {
      type: item.value,
      data: hasArray(data?.[item.value]) ? data?.[item.value] : undefined
    }
  }).filter(it => is_direct_cashback_point ? it.type === 'point' : it)

  const emptyState = !tables.some(it => it.data)

  return (
    <>
      {data && !state.resultDetail.isLoading && !state.resultDetail.isFetching && !emptyState && <Stack
        direction="row"
        justify="end"
        items="center"
        className="pb-8"
      >
        {permission.setVisibleByAccess(
          ['manage_campaign_sales_promo_export.read'],
          <Menu
            closeOnClick={true}
            className="min-w-[160px]"
            menuButton={(
              <Button loading={state.exportResultDetail.isLoading} variant="outlined" className='focus:ring-0'>
                Export Data
              </Button>
            )}
          >
            <MenuItem startIcon={XlsIcon} onClick={handleDownloadExport}>
              Export as XLS
            </MenuItem>
          </Menu>
        )}
      </Stack>}
      <QueryState query={state.resultDetail}>
        <></>
        <Stack direction='col' className='gap-6'>
          {emptyState ? <QueryStateContent title="No Data" description="The result has not been determined yet." /> : tables.map((item: { type: SALES_PROMO_RESULT_ITEMS, data?: SalesPromoResultItem[] }) => {
            return (
              <TablePrizesResult key={item.type} table={item} />
            )
          })}
        </Stack>
        <QueryStateContent title="No Data" description="The result has not been determined yet." />
      </QueryState>
    </>
  )
}

export default SalesPromoDetailTabResult

